import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
export var textColorMap = {
  info: 'var(--color-text-primary)',
  success: 'var(--color-constant-02)',
  error: 'var(--color-constant-02)',
  warning: 'var(--color-constant-01)'
};
export var subTitleOpacityMap = {
  info: 0.6,
  success: 0.6,
  error: 0.7,
  warning: 0.7
};
var defaultGetItemId = function defaultGetItemId(item) {
  return item.id;
};
var defaultGetItemMode = function defaultGetItemMode(item) {
  return item.mode;
};
var defaultGetItemTitle = function defaultGetItemTitle(item) {
  return item.title;
};
var defaultGetItemSubTitle = function defaultGetItemSubTitle(item) {
  return item.subTitle;
};
var defaultGetItemView = function defaultGetItemView(item) {
  return item.view;
};
export var composePreparedProps = function composePreparedProps(props) {
  return _objectSpread(_objectSpread({}, props), {}, {
    getItemId: props.getItemId || defaultGetItemId,
    getItemMode: props.getItemMode || defaultGetItemMode,
    getItemTitle: props.getItemTitle || defaultGetItemTitle,
    getItemSubTitle: props.getItemSubTitle || defaultGetItemSubTitle,
    getItemView: props.getItemView || defaultGetItemView
  });
};
export var defaultSnackBarAnimationTime = 300;